import styles from "./Contact.module.css";
import helpIcon from "../../../assets/icons/help.png";
import exitIcon from "../../../assets/icons/exit.svg";
import phoneIcon from "../../../assets/icons/phone.png";
import wappIcon from "../../../assets/icons/whatsappIcon.png";
import viberIcon from "../../../assets/icons/viberIcon.png";
import mailIcon from "../../../assets/icons/mail-white.png";
import React from "react";

const Contact = React.forwardRef(({ onClose, onContact }, ref) => {
    const copyTextHandler = (e) => {
        const value = e.currentTarget.getAttribute("value");

        navigator.clipboard.writeText(value).catch((err) => {
            console.error("Failed to copy: ", err);
        });
    };

    return (
        <div
            className={`${styles.container}  ${
                !onContact && styles[`container-closed`]
            } `}
            ref={ref}
        >
            <div className={styles.content}>
                <div className={styles[`info`]}>
                    <div className={styles.header}>
                        <div></div>
                        <img
                            src={exitIcon}
                            className={styles[`exit-icon`]}
                            onClick={onClose}
                        />
                    </div>
                    <div className={styles.description}>
                        <a
                            className={styles[`contact`]}
                            href={`tel:+38552637000`}
                            onClick={copyTextHandler}
                            target={"_blank"}
                            value={`+38552637000`}
                        >
                            <img
                                src={phoneIcon}
                                className={styles[`contact-icon`]}
                            />
                            +385 52 637 000
                        </a>
                        <a
                            className={styles[`contact`]}
                            href={`https://wa.me/38552637000`}
                            target={"_blank"}
                            onClick={copyTextHandler}
                            value={`+38552637000`}
                        >
                            <img
                                src={wappIcon}
                                className={styles[`contact-icon`]}
                            />
                            +385 95 731 7698
                        </a>
                        <a
                            className={styles[`contact`]}
                            href={`viber://contact?number=+38552637000`}
                            onClick={copyTextHandler}
                            target={"_blank"}
                            value={`+38552637000`}
                        >
                            <img
                                src={viberIcon}
                                className={`${styles[`contact-icon`]} ${
                                    styles[`viber`]
                                }`}
                            />
                            +385 95 731 7698
                        </a>
                        <a
                            className={styles[`contact`]}
                            href={`mailto:prodaja@gtnet.hr?subject=Upit Aktivacija`}
                            onClick={copyTextHandler}
                            target={"_blank"}
                            value={`prodaja@gtnet.hr`}
                        >
                            <img
                                src={mailIcon}
                                className={`${styles[`contact-icon`]} ${
                                    styles[`viber`]
                                }`}
                            />
                            prodaja@gtnet.hr
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
});
export default Contact;
